/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import "./style.less";

class PipelineProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  componentDidMount() {
    this.getProductListData();
  }

  getProductListData() {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (this.props.config.baseConfig.productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: this.props.config.baseConfig.sortType === '销量' ? 4 : 0,
        filter_subsidy: this.props.config.baseConfig.shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
            product.custom_recommend = customItem.recommend;
          }
        });
        this.setState({
          list,
        });
      }
    });
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;

    const options = {
      title: 6,
      type: baseConfig.productStyle,
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
  }

  render() {
    const { baseConfig, itemList } = this.props.config;
    const { componentDivideLine } = this.props
    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 750;
    const productList = this.state.list;
    // 转为数字处理，后续参与计算
    baseConfig.itemMargin = 6;
    
    return (
      <div
        className="pipeline-productList"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          backgroundColor: baseConfig.bgColor,
        }}
      >
        {baseConfig.showTitle && (
          <div>
            <div className="title" style={{ color: baseConfig.titleColor }}>
              {baseConfig.title}
            </div>
            <div className="sub-title" style={{ color: baseConfig.titleColor }}>
              {baseConfig.subTitle}
            </div>
          </div>
        )}
        {baseConfig.titleImg && (
          <img className="title-img" src={utils.formatImgUrl(baseConfig.titleImg, this.props.webpSupport)} alt="标题图" />
        )}
        <div className="product-list">
          {productList.map((item, index) => {
            let rowItemNumber = 3; // 每行排列数量
            if (baseConfig.productStyle === "一行一个") {
              rowItemNumber = 1;
            } else if (baseConfig.productStyle === "一行两个") {
              rowItemNumber = 2;
            } else if (baseConfig.productStyle === "一行三个") {
              rowItemNumber = 3;
            }

            // 行数计算
            const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
            const totalRowNum = Math.ceil(productList.length / rowItemNumber);
            const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
            const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 计算每个项的宽度
            const totalMargin = (rowItemNumber - 1) * baseConfig.itemMargin;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
              marginTop: isFirstRow ? "0" : `${baseConfig.itemMargin / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
              marginLeft: isFirstColumn
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
              marginRight: isLastColumn
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
            };

            let productItem;
            if (baseConfig.productStyle === "一行两个") {
              // 四个展示都存在是，隐藏销量
              if (
                baseConfig.originPrice &&
                baseConfig.saleNum &&
                baseConfig.priceIcon
              ) {
                baseConfig.saleNum = false;
              }
              // 计算一行二商品图片宽度
              const productImgWidth = (bodyWidth - 12 * 2 - Number(baseConfig.itemMargin)) / 2 - 6;
              productItem = (
                <div
                  className="product-item row-two-item"
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemClick.bind(this, item, index)}
                >
                  <div className="product-img-panel" style={{ width: productImgWidth, height: productImgWidth, margin: 3 }}>
                    <img className="product-img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} alt="" />
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <div
                        className="name"
                        style={{ WebkitBoxOrient: "vertical" }}
                      >
                        {item.custom_title || item.title}
                      </div>
                      {baseConfig.slogen && (
                        <div className="tag">
                          {(item.custom_recommend || item.recommend) && (
                            <div className="tag-text">
                              {item.custom_recommend || item.recommend}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price-container">
                        {baseConfig.priceIcon && (
                          <img
                            className="price-icon"
                            src={utils.formatImgUrl(baseConfig.priceIcon, this.props.webpSupport)}
                          />
                        )}
                        <div className="price">
                          <span className="rmb-icon">&yen;</span>
                          {item.price}
                        </div>
                        {baseConfig.originPrice &&
                          item.original_price > item.price &&
                          item.original_price > 0 && (
                            <span className="origin-price">
                              &yen;{item.original_price}
                            </span>
                          )}
                      </div>
                      {baseConfig.saleNum && item.sell_point > 0 && (
                        <div className="num">{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                      )}
                    </div>
                  </div>
                </div>
              );
            } else if (baseConfig.productStyle === "一行三个") {
              // 四个展示都存在是，隐藏销量
              if (baseConfig.originPrice && baseConfig.saleNum) {
                baseConfig.saleNum = false;
              }
              // 计算一行三商品图片宽度
              const productImgWidth = (bodyWidth - 12 * 2 - Number(baseConfig.itemMargin)  * 2) / 3;

              // 折扣计算
              let discountRate = item.price / item.original_price;
              if (
                discountRate > 1 ||
                isNaN(discountRate) ||
                item.original_price === 0
              ) {
                discountRate = 1;
              }
              discountRate = discountRate * 10;
              discountRate = discountRate.toFixed(1);

              productItem = (
                <div
                  className="product-item row-three-item"
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemClick.bind(this, item, index)}
                >
                  <div className="product-img-panel" style={{ width: productImgWidth, height: productImgWidth }}>
                    <img className="product-img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} alt="" />
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <div
                        className="name"
                        style={{ WebkitBoxOrient: "vertical" }}
                      >
                        {item.custom_title || item.title}
                      </div>
                      {baseConfig.slogen && (
                        <div className="tag">
                          {(item.custom_recommend || item.recommend) && (
                            <div className="tag-text">
                              {item.custom_recommend || item.recommend}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price">
                        <span className="rmb-icon">&yen;</span>
                        {item.price}
                      </div>
                      {baseConfig.originPrice &&
                        item.original_price > item.price &&
                        item.original_price > 0 && (
                          <span className="origin-price">
                            &yen;{item.original_price}
                          </span>
                        )}
                      {baseConfig.saleNum && !baseConfig.originPrice && !baseConfig.discount && item.sell_point > 0 && (
                        <div className="num">{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                      )}
                    </div>
                  </div>
                  {(baseConfig.discount && discountRate !== "10.0") && (
                    <div className="discount-panel" style={{backgroundImage: `url(${utils.formatImgUrl(baseConfig.discountBg, this.props.webpSupport)})`}}>
                      <span className="num">{discountRate}</span>
                      折
                    </div>
                  )}
                </div>
              );
            }
            return productItem;
          })}
        </div>
        {this.props.notLastItem && componentDivideLine && (
          <img className="component-divide-line" src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)} />
        )}
      </div>
    );
  }
}

PipelineProductList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProductList };
export default PipelineProductList;



// WEBPACK FOOTER //
// ./components/pipeline-productList/index.js